export enum BlockType {
  Loop = 1,
  Group = 2,
  MultiBlock = 3,
  LoopParent = 4
}
